var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-horizontal',{scopedSlots:_vm._u([{key:"navbar",fn:function(ref){
var toggleVerticalMenuActive = ref.toggleVerticalMenuActive;
return [_c('navbar',{attrs:{"toggle-vertical-menu-active":toggleVerticalMenuActive}})]}}])},[_c('router-view'),_c('div',{staticClass:"p-0",attrs:{"slot":"breadcrumb"},slot:"breadcrumb"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }